import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Tabs, type TabsProps } from '@jouzen/ecom-components/v3/Tabs';
import { useTranslations } from 'next-intl';
import type { JSX } from 'react';

import LandingPageMembershipTabContent from '@/app/components/LandingPage/LandingPageMembershipTabs/LandingPageMembershipTabContent';
import type { LandingPageMembershipTabData } from '@/app/components/LandingPage/LandingPageMembershipTabs/LandingPageMembershipTabContent/LandingPageMembershipTabContentCard';
import useTrustedAdvisorRollout from '@/app/hooks/useTrustedAdvisorRollout';

import getLandingPageMembershipTabData from './_utils/getLandingPageMembershipTabData';

export interface LandingPageMembershipTabsProps {
  readonly tabsData?: LandingPageMembershipTabData[] | undefined;
}

const LandingPageMembershipTabs = ({
  tabsData: _tabsData,
}: LandingPageMembershipTabsProps) => {
  const t = useTranslations();
  // TODO: GROW-2946 Clean up trusted advisor rollout
  const isTrustedAdvisorEnabled = useTrustedAdvisorRollout();

  const tabsData =
    _tabsData ?? getLandingPageMembershipTabData(isTrustedAdvisorEnabled);
  const tabs: TabsProps['tabs'] = tabsData.map(({ Icon, tab }) => ({
    className: 'px-0 py-3',
    icon: <Icon className="mr-2" height="22" width="22" />,
    label: t(tab.label),
  }));
  const tabPanels: TabsProps['tabPanels'] = tabsData.map(
    ({
      backgroundColor,
      Icon,
      id,
      tabPanel,
    }: LandingPageMembershipTabData) => ({
      content: (
        <LandingPageMembershipTabContent
          cards={tabPanel.cards.map((card) => ({ ...card, backgroundColor }))}
          featuredImage={{ ...tabPanel.featuredImage, Icon }}
          key={id}
        />
      ),
    }),
  );
  return (
    <Tabs
      scrollableTablist
      tabList={{
        tabWrapperComponent: LayoutGrid as unknown as () => JSX.Element,
        className: 'gap-x-8 lg:gap-x-10 xl:gap-x-14 xxl:gap-x-20',
        containerClass: 'col-start-main col-end-main',
      }}
      tabs={tabs}
      tabPanels={tabPanels}
    />
  );
};

export default LandingPageMembershipTabs;
